<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-hnb-' + id"
    data-toggle='collapse'
    :data-target="'#collapse-hnb-' + id"
    :aria-controls="'collapse-hnb-' + id"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_HNB", 1) }}
  .collapse.show(
    :aria-labelledby="'heading-hnb-' + id"
    :id="'collapse-hnb-' + id"
  )
    .card-body.p-0
      .market-card-content
        .two-column(v-if="mode == 0 || mode == 1")
          .two-column-title {{ $t("ui.full_time") }}
          .two-column-content
            .two-column-group
              .two-column-odd-area
                .two-column-odd-area-oddtype
                  p.mb-0 {{ $tc("m.BT_D", 1) }}
                .two-column-odd-area-group
                  template(v-if="moreItems['hnbo'] && moreItems['hnbo']['D'] && moreItems['hnbo']['D'][6] && moreItems['hnbo']['D'][5] != 0 && moreItems['hnbo']['D'][5] != ''")
                    OddsItem(:odds="moreItems['hnbo']['D']" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
            .two-column-group
              .two-column-odd-area
                .two-column-odd-area-oddtype
                  p.mb-0 {{ $tc("m.BT_A", 1) }}
                .two-column-odd-area-group
                  template(v-if="moreItems['hnbo'] && moreItems['hnbo']['A'] && moreItems['hnbo']['A'][6] && moreItems['hnbo']['A'][5] != 0 && moreItems['hnbo']['A'][5] != ''")
                    OddsItem(:odds="moreItems['hnbo']['A']" idx=5 :typ="oddsType" dataType="3")
                  template(v-else)
                    OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  }
}
</script>